type DeltaProps = {
  value: number | null;
  suffix?: string;
  size?: number;
};

export function Delta(props: DeltaProps) {
  const suffix = () => props.suffix ?? "";
  const size = () => `${props.size ?? 12}px`;
  const value = () => props.value ?? 0;
  const up = () => value() > 0;

  if (props.value === null || props.value === 0) {
    return (
      <span class="delta delta-flat" style={{ "font-size": size() }}>
        ±0{suffix()}
      </span>
    );
  }

  return (
    <span
      class={`delta ${up() ? "delta-up" : "delta-down"}`}
      style={{ "font-size": size() }}
    >
      <svg width="9" height="9" viewBox="0 0 10 10" aria-hidden="true">
        <path
          d={up() ? "M5 1 L9 7 L1 7 Z" : "M5 9 L1 3 L9 3 Z"}
          fill="currentColor"
        />
      </svg>
      {Math.abs(value())}
      {suffix()}
    </span>
  );
}
